import React from 'react'

const HomeIcon = (
  <>
    <path
      d="M9.99985 0.871094L2.60889 7.44076V18.6963C2.60889 18.9269 2.7005 19.1481 2.86356 19.3111C3.02663 19.4742 3.2478 19.5658 3.47841 19.5658H16.5213C16.7519 19.5658 16.9731 19.4742 17.1361 19.3111C17.2992 19.1481 17.3908 18.9269 17.3908 18.6963V7.44076L9.99985 0.871094Z"
      fill="#E3E3E3"
    />
    <path
      d="M19.5646 10.0009C19.4564 10.0009 19.3521 9.96061 19.272 9.88783L9.99981 1.45826L0.727634 9.88783C0.64225 9.96543 0.529536 10.0059 0.414288 10.0004C0.29904 9.99493 0.190698 9.94387 0.113097 9.85849C0.0354961 9.7731 -0.00500785 9.66039 0.000495682 9.54514C0.00599921 9.42989 0.0570594 9.32155 0.142444 9.24395L9.70722 0.54874C9.78726 0.475908 9.89159 0.435547 9.99981 0.435547C10.108 0.435547 10.2124 0.475908 10.2924 0.54874L19.8572 9.24395C19.9223 9.30295 19.968 9.3803 19.9883 9.46579C20.0085 9.55128 20.0024 9.64091 19.9708 9.72287C19.9391 9.80482 19.8833 9.87525 19.8108 9.92488C19.7383 9.97451 19.6525 10.001 19.5646 10.0009Z"
      fill="#FF7163"
    />
    <path
      d="M11.7385 13.9141H8.26045C8.14514 13.9141 8.03456 13.9599 7.95302 14.0414C7.87149 14.1229 7.82568 14.2335 7.82568 14.3488V19.566H12.1733V14.3488C12.1733 14.2335 12.1275 14.1229 12.046 14.0414C11.9644 13.9599 11.8539 13.9141 11.7385 13.9141Z"
      fill="#BF8C5A"
    />
    <path
      d="M11.7385 11.3062H8.26045C8.14514 11.3062 8.03456 11.2604 7.95302 11.1789C7.87149 11.0973 7.82568 10.9868 7.82568 10.8714V8.26289C7.82568 8.14758 7.87149 8.037 7.95302 7.95546C8.03456 7.87393 8.14514 7.82812 8.26045 7.82812H11.7385C11.8539 7.82812 11.9644 7.87393 12.046 7.95546C12.1275 8.037 12.1733 8.14758 12.1733 8.26289V10.8714C12.1733 10.9868 12.1275 11.0973 12.046 11.1789C11.9644 11.2604 11.8539 11.3062 11.7385 11.3062Z"
      fill="#3AACE9"
    />
  </>
)

export default HomeIcon
